import script from "./figmaLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./figmaLogin.vue?vue&type=script&setup=true&lang=js"

import "./figmaLogin.vue?vue&type=style&index=0&id=6a686394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a686394"]])

export default __exports__